import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from '../../http.service';

@Component({
  selector: 'app-by-product-gatepass',
  templateUrl: './by-product-gatepass.component.html',
  styleUrls: ['./by-product-gatepass.component.scss']
})
export class ByProductGatepassComponent implements OnInit {
  title = '';
  by_product_order_list = []
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  showProduct = false;
  selected_index = null;
  today_date: any = new Date().toISOString().split('T')[0];

  constructor(private globalService: GlobalService, private httpService: HttpService) {
    this.title = this.globalService._active_display_name;
    this.is_data_available = false;
    this.serveGatePass();
  }

  serveGatePass() {
    this.httpService.serveByProductOrderForGatepass().subscribe(async (data: any) => {
      this.today_date = await this.httpService.getCurrentDate();
      this.today_date = new Date(this.today_date).toISOString().split('T')[0]
      console.log(data);
      this.is_data_available = true;
      this.by_product_order_list = data;
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }

  deleteSaleClicked(sale_group_id) {
    if (confirm('Are you sure want to delete')) {
      let data_dict = {
        'id': sale_group_id
      };
      this.httpService.deleteSelectedSale(data_dict).subscribe((data) => {
        console.log(data);
        alert('Delete Successfully')
        this.serveGatePass();
      }, (error) => {
        alert('error while deleteing')
        console.error(error);
      });
    }
  }

  showProductClicked(index) {
    if (this.selected_index == index) {
      this.selected_index = null
    } else {
      this.selected_index = index;
    }
  }

  gatePassCalled(order_data, order_index) {
    let by_sale_group_id = order_data['by_sale_group_id'];
    if (order_data['is_for'] == 'Agent') {
      let data_dict = {
        'by_sale_group_id': by_sale_group_id
      };
      this.httpService.prepareGatepassForByProduct(data_dict).subscribe((data) => {
        console.log(data);
        this.by_product_order_list[order_index]['sale_status_id'] = 2
      }, (error) => {
        console.error(error);
      });

    } else {
      let data_dict = {
        'by_sale_group_id': by_sale_group_id
      };
      this.httpService.prepareGatepassForByProductEmployee(data_dict).subscribe((data) => {
        console.log(data);
        this.by_product_order_list[order_index]['sale_status_id'] = 2
      }, (error) => {
        console.error(error);
      });
    }
  }

  downloadGatePass(order_data, document_for) {
    let data_dict = {
      'by_sale_group_id': order_data['by_sale_group_id'],
      'count': 2,
      'for': document_for
    };
    if (order_data['is_for'] == 'Agent') {
      this.httpService.downloadByProductGatePass(data_dict).subscribe((data) => {
        console.log(data);
        const linkSource = 'data:application/pdf;base64,' + data['pdf'];
        const downloadLink = document.createElement("a");
        const fileName = data['file_name'];
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }, (error) => {
        console.error(error);
      });
    } else {
      this.httpService.downloadByProductGatePassForEmployee(data_dict).subscribe((data) => {
        console.log(data);
        const linkSource = 'data:application/pdf;base64,' + data['pdf'];
        const downloadLink = document.createElement("a");
        const fileName = data['file_name'];
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }, (error) => {
        console.error(error);
      });
    }
  }


  ngOnInit() {
  }

}
